import ExternalAudience from 'owa-service/lib/contract/ExternalAudience';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import {
    getIsAutomaticReplyEnabled,
    getSendRepliesOutsideOrgEnabled,
    getSendRepliesToContactsOnlyEnabled,
} from '../selectors/getStoreProperties';

/**
 * Utility function to get external audience
 * @returns external audience status of type ExternalAudience
 */
export default function getExternalAudience() {
    let isEnterpriseUser = !isConsumer();
    let isAutomaticReplyEnabled = getIsAutomaticReplyEnabled();
    if (!isAutomaticReplyEnabled) {
        return ExternalAudience.None;
    }
    let sendRepliesOutsideOrgEnabled = getSendRepliesOutsideOrgEnabled();
    if (isEnterpriseUser && !sendRepliesOutsideOrgEnabled) {
        return ExternalAudience.None;
    }
    let sendRepliesToContactsOnlyEnabled = getSendRepliesToContactsOnlyEnabled();
    return sendRepliesToContactsOnlyEnabled ? ExternalAudience.Known : ExternalAudience.All;
}
